import React, { useEffect, useMemo, useState } from 'react'
import { Alert, Box, Dialog } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { isSessionExpired, onSessionExpired } from '@/services/sessionExpiredEvents'
import { PUBLIC_PATHS } from '@/constants/routerConstants'
import { getAccessToken } from '@/utils/authUtils'
import { docBanOnlineOauthKetQua } from '@/utils/banOnlineOauthCallback'
import SignInForm from './SignInForm'

const SessionExpiredLoginModal: React.FC = () => {
  const { pathname, search } = useLocation()
  const [expired, setExpired] = useState(isSessionExpired)
  const oauthKetQua = useMemo(() => docBanOnlineOauthKetQua(search), [search])

  useEffect(() => onSessionExpired(() => setExpired(true)), [])

  if (PUBLIC_PATHS.includes(pathname)) return null

  const hasToken = !!getAccessToken()

  return (
    <Dialog
      open={expired || !hasToken}
      disableEscapeKeyDown
      PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'visible', m: 2 } }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
        {oauthKetQua ? (
          <Alert
            severity={oauthKetQua.thanhCong ? 'success' : 'error'}
            sx={{ width: '100%', maxWidth: 390 }}
          >
            {oauthKetQua.thongBao}
          </Alert>
        ) : null}
        <Alert severity="warning" sx={{ width: '100%', maxWidth: 390 }}>
          {hasToken
            ? 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại để tiếp tục.'
            : 'Bạn chưa đăng nhập. Vui lòng đăng nhập để tiếp tục.'}
        </Alert>
        <SignInForm onSuccess={() => window.location.reload()} />
      </Box>
    </Dialog>
  )
}

export default SessionExpiredLoginModal
